import React from "react";
import { EuiCheckbox } from "@elastic/eui";
import { Controller } from "react-hook-form";

const CheckBoxField = (props) => {
  const { name, defaultValue, control, setValue } = props;
  return (
    <Controller
      render={({ onChange, value }) => (
        <EuiCheckbox
          onChange={(e) => {
            onChange(e.target.checked);
            setValue(name, e.target.checked);
          }}
          checked={value}
          compressed
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
};

export default CheckBoxField;
